import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import LoginView from '@/views/LoginView.vue';
import { useAuth } from '@/store/auth';
import CalculatorView from '@/views/CalculatorView.vue';
import AnalyticsView from '@/views/AnalyticsView.vue';
import CarFaxView from '@/views/CarFaxView.vue';
import KlaipedaPortView from '@/views/KlaipedaPortView.vue';
import USAPortView from '@/views/USAPortView.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: CalculatorView,
    meta: { requiresAuth: true },
  },
  {
    path: '/calculator',
    name: 'calculator',
    component: CalculatorView,
    meta: { requiresAuth: true },
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: AnalyticsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/car-fax',
    name: 'car-fax',
    component: CarFaxView,
    meta: { requiresAuth: true },
  },
  {
    path: '/klaipeda-port',
    name: 'klaipeda-port',
    component: KlaipedaPortView,
    meta: { requiresAuth: true },
  },
  {
    path: '/usa-port',
    name: 'usa-port',
    component: USAPortView,
    meta: { requiresAuth: true },
  },
  {
    path: '/auth/login',
    name: 'auth-login',
    component: LoginView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const auth = useAuth();
  const isAuthV = await auth.isAuth();

  if (isAuthV && to.name === 'auth-login') {
    next({ name: 'calculator' });
  } else if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !isAuthV
  ) {
    next({ name: 'auth-login' });
  } else {
    next();
  }
});

export default router;
